import { render, staticRenderFns } from "./mobileSidebar.vue?vue&type=template&id=2a49b430&scoped=true"
import script from "./mobileSidebar.vue?vue&type=script&lang=js"
export * from "./mobileSidebar.vue?vue&type=script&lang=js"
import style0 from "./mobileSidebar.vue?vue&type=style&index=0&id=2a49b430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49b430",
  null
  
)

export default component.exports